/* eslint-disable */
import { AxiosResponse } from 'axios';
import { APIError } from '../types/types';
import { DropDownData } from '../components/shared/interface/CostBasedPricingInterface';

export const sanitizeURL = (url: string): string => {
  if (!url) {
    return '';
  }

  const badURLRegex = RegExp('^((https)|(http)):/{3,}');
  const isBadURL = badURLRegex.test(url);

  if (isBadURL) {
    return 'https://' + url.replace(badURLRegex, '');
  }

  return url;
};

export const getErrorMessage = (response?: AxiosResponse<APIError>) => {
  if (response?.status === 400 && response?.data.errors[0].code) {
    return response?.data.errors[0].message;
  }

  return null;
};

export function transformString(input: string): string {
  const trimmedInput = input.trim();
  if (!trimmedInput) {
    return '';
  }
  switch (trimmedInput) {
    case "STOREZONE": return "StoreZone";
    case "CANCEL": return "Cancelled";
    case "PARTIAL": return "Partially Completed";
    case "VERIFYPRC": return "Verification In-progress";
    case "WAITING": return "Waiting for Approval";
    case "REMOVE": return "Remove Pricing";
    case "SECONDARY": return "Secondary Criteria";
    case "COSTRULES": return "Cost Based Pricing";
    case "ZONERULES": return "Zone Based Pricing";
    case "REMOVESC": return "Remove Secondary Criteria";
    default: return trimmedInput.charAt(0).toUpperCase() + trimmedInput.slice(1).toLowerCase();
  }
}

export function mapDropDownData(data: any[], labelKey: string, valueKey: string) {
  let array: DropDownData[] = []
  data?.map((val) => {
    array.push({
      label: val[labelKey]?.toUpperCase(),
      value: val[valueKey],
    })
  })
  array.sort((a: any, b: any) => a.label?.localeCompare(b.label))
  array.unshift({
    label: "Select",
    value: "",
  })
  return array;
}

export function filterHierarchy(data: any[], key: string, value: string | number) {
  const response = data?.filter((val) => {
    return val[key] == value
  })
  return response;
}

export function formatApiError(err: any): string | null {
  if (!err) return null;
  const raw = err?.data?.errors?.[0]?.error;
  let parsed: { message?: string; ttl?: number; supportContact?: string } = {};
  if (typeof raw == 'string') {
    try {
      parsed = JSON.parse(raw);
    } catch {
      parsed = { message: raw };
    }
  } else if (raw && typeof raw == 'object') {
    parsed = raw;
  }
  const message = parsed.message?.trim();
  if (!message) return null;
  const lower = message.toLowerCase();
  if (lower == 'invalid pin') return 'Invalid PIN';

  if (lower == 'account temporarily locked.') {
    const ttl = Number(parsed.ttl);
    const supportContact = parsed.supportContact;
    if (Number.isFinite(ttl) && ttl > 0) {
      return `Too many failed PIN attempts. Please try again in ${ttl} minutes, or contact RAC Support at ${supportContact} for assistance.`;
    }
    return 'Too many failed PIN attempts. Please try again later, or contact RAC Support for assistance.';
  }
  return message;
}
